import { AccessorsMutatorsDecorator, Model } from "../../helpers";
import { Furniture } from "./furniture.model";

/**
 * @class FurnitureItem
 * 
 */
export class FurnitureItem extends Model {

    
    static get NEW() {
        
        return 1;
    }
    
    static get USED() {
        
        return 2;
    }
    
    static get UNDER_MAINTENANCE() {
        
        return 3;
    }
    
    /**
     * @param {Object|Furniture} value
     * @returns {Furniture}
     */
    setFurniture(value) {
        
        return value instanceof Furniture ? value : new Furniture(value);
    }
}

AccessorsMutatorsDecorator('id', 'furniture', 'ident', 'status', 'assets')(FurnitureItem);


// WEBPACK FOOTER //
// ./src/pms-api/models/furniture-item.model.js